module.exports = __webpack_public_path__ + "static/media/image_2.0d072c8c.png";